import { render, staticRenderFns } from "./JSelectDepartModal.vue?vue&type=template&id=06cae5fd&scoped=true&"
import script from "./JSelectDepartModal.vue?vue&type=script&lang=js&"
export * from "./JSelectDepartModal.vue?vue&type=script&lang=js&"
import style0 from "./JSelectDepartModal.vue?vue&type=style&index=0&id=06cae5fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cae5fd",
  null
  
)

export default component.exports